import React, { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import CustomModal from "../basics/interface/CustomModal"
import { generalStyles } from "../styles/styles"

// Version V2 (CustomModal) de AtelierSousTraitantsModal — sélection d'un
// fournisseur sous-traitant pour la main d'œuvre. Props identiques au legacy.
const AtelierSousTraitantsModalV2 = ({
	closeModal,
	addAtelierLigneSousTraitant,
}) => {
	const [selectedFournisseur, setSelectedFournisseur] = useState(0)
	const { fournisseurs } = useSelector((state) => state.autreInfo)
	const filteredFournisseurs = useMemo(
		() => fournisseurs.filter((f) => f.prix_achat),
		[fournisseurs],
	)
	const add = () => {
		addAtelierLigneSousTraitant(selectedFournisseur)
		closeModal()
	}
	return (
		<CustomModal
			title={"Main d'œuvre sous-traitant"}
			onClose={closeModal}
			maxWidth={440}
			buttons={[
				{
					title: "Ajouter",
					styleName: "primary",
					onClick: add,
					disabled: selectedFournisseur === 0,
				},
			]}
		>
			<select
				style={generalStyles.select}
				value={selectedFournisseur}
				onChange={(e) =>
					setSelectedFournisseur(parseInt(e.target.value))
				}
			>
				<option value={0}>-</option>
				{filteredFournisseurs.map((f) => (
					<option key={`astm_${f.id}`} value={f.id}>
						{f.label}
					</option>
				))}
			</select>
		</CustomModal>
	)
}

export default AtelierSousTraitantsModalV2
